// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apiURL: 'https://sachem-test.syensqo.com',
  environmentName: 'test',
  useEmulators: true,
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyC1x9drjF63FH0ysd18A0Tyskx3OzW1ptk",
    authDomain: "gcp-sqo-sachem-t.firebaseapp.com",
    projectId: "gcp-sqo-sachem-t",
    storageBucket: "gcp-sqo-sachem-t.appspot.com",
    messagingSenderId: "247994021051",
    appId: "1:247994021051:web:c8f016759cdc482d91a59e"
  },
  recaptchaSiteKey: '6LdKSE8qAAAAAIr0lJcXyu01Z1CzB59XxGtJBrZU',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
